import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ScenarioAcsPickerComponent } from './components/scenario-acs-picker/scenario-acs-picker.component';
import { ScenarioBuilderPageComponent } from './components/scenario-builder-page/scenario-builder-page.component';
import { ScenarioDropdownComponent } from './components/scenario-dropdown/scenario-dropdown.component';
import { ScenarioPlayerComponent } from './components/scenario-player/scenario-player.component';
import { ScenarioQuestionComponent } from './components/scenario-question/scenario-question.component';
import { ScenarioToasterComponent } from './components/scenario-toaster/scenario-toaster.component';
import { ScenarioWalkthroughComponent } from './components/scenario-walkthrough/scenario-walkthrough.component';

@NgModule({
  imports: [CommonModule, DragDropModule, FormsModule, OverlayModule],
  declarations: [ScenarioBuilderPageComponent, ScenarioPlayerComponent, ScenarioQuestionComponent, ScenarioDropdownComponent,
    ScenarioWalkthroughComponent, ScenarioAcsPickerComponent, ScenarioToasterComponent],
  exports: [ScenarioBuilderPageComponent],
})
export class ScenariosModule { }
